var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4853 38.5C37.7074 38.5 36.9883 38.5 36.2104 38.5C36.2104 26.7877 36.2104 15.1047 36.2104 3.33366C24.454 3.33366 12.7564 3.33366 1.01468 3.33366C1 2.51174 1 1.77789 1 1C13.4902 1 25.9657 1 38.4853 1C38.4853 13.4902 38.4853 25.9658 38.4853 38.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.092 38.5C28.3141 38.5 27.5949 38.5 26.817 38.5C26.817 29.9139 26.817 21.3571 26.817 12.727C18.1869 12.727 9.63014 12.727 1.01468 12.727C1 11.9051 1 11.1712 1 10.3933C10.364 10.3933 19.6986 10.3933 29.092 10.3933C29.092 19.7426 29.092 29.1066 29.092 38.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3061 30.9854C9.64565 30.3396 9.13195 29.8405 8.57422 29.2975C12.0967 25.775 15.6192 22.2672 19.2592 18.6272C17.3658 18.6272 15.6779 18.6272 13.9314 18.6272C13.9314 17.82 13.9314 17.0861 13.9314 16.2936C17.0136 16.2936 20.0957 16.2936 23.222 16.2936C23.222 19.3904 23.222 22.4873 23.222 25.5989C22.4734 25.5989 21.7396 25.5989 20.9323 25.5989C20.9323 23.8816 20.9323 22.1644 20.9323 20.3591C17.3365 23.955 13.8286 27.4629 10.3061 30.9854Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65639 34.4198C4.11138 34.8748 4.62508 35.3885 5.1241 35.8875C4.59572 36.4159 4.06735 36.9443 3.52429 37.502C3.0693 37.003 2.57028 36.4452 2.08594 35.9169C2.52625 35.4766 3.0693 34.9629 3.65639 34.4198Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35066 32.7466C7.91035 33.1722 7.38197 33.6712 6.88295 34.1556C6.38393 33.6566 5.84088 33.1135 5.3125 32.5851C5.79684 32.0861 6.31054 31.5724 6.80956 31.0587C7.32326 31.6164 7.82228 32.1595 8.35066 32.7466Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon01);
export default __webpack_public_path__ + "static/media/services_icon01.75c26d9b4ad964dc058430f0507e2c1f.svg";
export { ForwardRef as ReactComponent };